<template>
  <div class="our-beliefs-technology-content" id="plataforma-de-marca-nossas-crencas-tecnologia-e-conteudo-andam-juntos" data-search-anchor>
    <div class="our-beliefs-technology-overlay-title-image">
      <h1 class="our-beliefs-technology-image-technology-title" style="margin-top: 4rem;">
        {{ ourBeliefsTechnologyImageTitle }}
      </h1>
      <h1 class="our-beliefs-technology-image-technology-title" style="margin-bottom: 2rem;">
        {{ ourBeliefsTechnologyImageTitle2 }}
      </h1>
      <p class="our-beliefs-technology-image-technology-text">
        {{ ourBeliefsTechnologyImageTitle3 }}
      </p>
    </div>

    <div
      class="our-beliefs-technology-banner-image"
      :style="{ backgroundImage: `url(${ourBeliefsTechnologyImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import OurBeliefsPageMixin from '@/mixins/our-beliefs-page-mixin'
import { OurBeliefsPageStore } from '@/store/brand-plataform-page/our-beliefs-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurBeliefsTechnologySection extends Mixins(OurBeliefsPageMixin) {
  ourBeliefsPageStore: PageStoreContract = getModule(OurBeliefsPageStore, this.$store)

  get ourBeliefsTechnologyImageTitle(): string {
    return this.getElementText(2, 0)
  }

  get ourBeliefsTechnologyImageSrc(): string {
    return this.getElementMedia(2, 0)
  }

  get ourBeliefsTechnologyImageTitle2(): string {
    return this.getElementText(2, 1)
  }

  get ourBeliefsTechnologyImageTitle3(): string {
    return this.getElementText(2, 2)
  }

  async getOurBeliefsPageStore(): Promise<void> {
    await this.ourBeliefsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.ourBeliefsPageStore.isLoading) {
      await this.getOurBeliefsPageStore()
    }
  }
}
</script>

<style lang="scss">
.our-beliefs-technology-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;    
}

.our-beliefs-technology-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.our-beliefs-technology-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.our-beliefs-technology-image-technology-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.our-beliefs-technology-image-technology-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
